var _style, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlastic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-260 340.5 90 112.5",
    style: {
      enableBackground: "new -260 340.5 90 112.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;stroke:#DF8F44;stroke-width:2.8346;stroke-miterlimit:10;}\r\n\t.st1{fill:#DF8F44;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-181.1,451.7h-67.9c-5.5,0-10-4.5-10-10v-89.8c0-5.5,4.5-10,10-10h67.9c5.5,0,10,4.5,10,10v89.8 C-171.1,447.2-175.6,451.7-181.1,451.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-227.9,390.8l-0.5-1.6l0,0l-0.1-0.2c0,0,0-0.1,0-0.2c-2.8,0.1-4.3,0.4-5.8,0.8c-1.5,0.4-3,0.7-5.9,0.7 s-4.4-0.3-5.9-0.7c-1.6-0.4-3.3-0.8-6.7-0.8c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c3,0,4.4,0.3,5.9,0.7 c1.6,0.4,3.3,0.8,6.7,0.8s5-0.4,6.7-0.8c1.5-0.4,3-0.7,5.9-0.7l0,0L-227.9,390.8L-227.9,390.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-177.3,388.7c-3.3,0-5,0.4-6.7,0.8c-1.5,0.4-3,0.7-5.9,0.7c-3,0-4.4-0.3-5.9-0.7c-1.6-0.4-3.3-0.8-6.7-0.8 c-2.4,0-3.9,0.2-5.2,0.5l0.4,1.4l0.5,1.6c1.1-0.2,2.4-0.4,4.3-0.4c3,0,4.4,0.3,5.9,0.7c1.6,0.4,3.3,0.8,6.7,0.8 c3.3,0,5-0.4,6.7-0.8c1.5-0.4,3-0.7,5.9-0.7c0.9,0,1.6-0.7,1.6-1.6C-175.7,389.3-176.4,388.7-177.3,388.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-207.7,389.2c-0.5,0.1-1,0.2-1.5,0.3c-1.5,0.4-3,0.7-5.9,0.7c-3,0-4.4-0.3-5.9-0.7c-1.6-0.4-3.3-0.8-6.7-0.8 c-0.3,0-0.6,0-0.8,0l0,0c-0.4-1.9-0.3-3.8,0.4-5.6l1.1-2.5c0.5-1.2,0.6-2.6,0.2-3.9l-3.6-12.1c-0.1-0.4-0.1-0.8,0.1-1.2 c0.2-0.4,0.5-0.6,0.9-0.8l6.3-1.9c0.8-0.3,1.7,0.2,2,1.1l3.6,12.1c0.4,1.3,1.2,2.4,2.3,3.2l2.2,1.5c1.7,1.2,3,2.9,3.6,4.9 L-207.7,389.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-204.2,405.8c-0.6,1.1-1.6,1.9-2.8,2.2l-10.1,3c-0.4,0.1-0.9,0.2-1.3,0.2c-0.8,0-1.5-0.2-2.2-0.6 c-1.1-0.6-1.9-1.6-2.2-2.8l-4.7-16c2.9,0,4.4,0.3,5.9,0.7c1.6,0.4,3.3,0.8,6.7,0.8c3.3,0,5-0.4,6.7-0.8c0.5-0.1,1.1-0.3,1.6-0.3 l3,10C-203.4,403.5-203.6,404.7-204.2,405.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-191.9,402.8c-2.8,0-5,2.2-5,5s2.2,5,5,5s5-2.2,5-5S-189.2,402.8-191.9,402.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: -206.7,
    cy: 421,
    r: 6.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-238.3,428.9l3.1,3.4c0.3,0.3,0.7,0.5,1.1,0.5c0.2,0,0.5,0,0.7-0.2l10.3-4.9c0.6-0.3,1-1,0.9-1.6l-0.6-4.5 L-238.3,428.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-234.7,399.8c-0.5-0.5-1.2-0.6-1.8-0.4l-10.3,4.9c-0.6,0.3-1,0.9-0.9,1.6l0.6,4.5l15.5-7.3L-234.7,399.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-229.8,405.8 -246.1,413.5 -239.9,426.3 -223.7,418.5  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlastic);
export default __webpack_public_path__ + "static/media/plastic.a776fd8850cef5cfe75e07f52680ac6c.svg";
export { ForwardRef as ReactComponent };